<template>
  <div>
    <div
      v-for="(page, index) in pageGroupedElements"
      :key="'page-' + index"
      class="position-relative dinA4"
    >
      <img :src="require('@/assets/peninsular-header.png')" class="mb-0 page__header" />
      <div class="page__container">
        <div v-for="(element, elementIndex) in page" :key="'element-' + elementIndex">
          <div v-if="element.type === 'table'" class="d-flex justify-center">
            <PdfProductTable
              type="peninsular"
              :tableData="productTableList[element.id]"
              :tableId="element.id"
              :image="element.imageUrl"
            />
          </div>
          <div v-else class="d-flex justify-center mb-10">
            <div class="small-letter-section">
              <p class="small-letter-font small-letter-font--bold mb-0">
                {{ element.title }}
              </p>
              <ul class="small-letter-font justify-text">
                <li
                  v-for="(listElement, listIndex) in element.list"
                  :key="'listElement-' + listIndex"
                  v-html="listElement"
                />
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Footer logo :page="previousPages + 1 + index" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_PDF_PRODUCT_TABLE_LIST } from '@/store/modules/offer/getters'
import PdfProductTable from '@/containers/offer-form/sign-off/pdf-venta-directa-2022/PdfProductTable'
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2022/Footer'

export default {
  name: 'PeninsularTables',
  components: {
    PdfProductTable,
    Footer,
  },
  data() {
    return {
      elements: [
        {
          type: 'table',
          imageUrl: require('@/assets/ctt24-icon.png'),
          id: '24H',
        },
        {
          type: 'text',
          title: 'Características de los servicios Ctt 24h y Ctt e24h:',
          list: [
            '- Peso máximo por bulto: 40 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. Este servicio admite exceso de peso y exceso de medida (consultar pág. 10 de este documento).',
            '- Cubicaje: Conversión volumétrica 167kg/m3',
            '- El servicio Ctt e24h que disponga de teléfono móvil, se beneficiará GRATIS del <u>Preaviso de entrega</u>, el servicio de <u>Entrega flexible</u> y la <u>Predicción de franja horaria</u>.',
            '- Se admite la recogida y entrega en más de 200 puntos CTT Express con un servicio 24h sin coste adicional',
            '- El Servicio Portugal incluye la entrega en más de 1,800 puntos de conveniencia <u>sin coste adicional</u>.',
          ],
        },
        {
          type: 'table',
          imageUrl: require('@/assets/ctt1330-icon.png'),
          id: '13h',
        },
        {
          type: 'text',
          title: 'Características del servicio Ctt 14:00h:',
          list: [
            '- Peso máximo por bulto: 40 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. Este servicio admite exceso de peso y exceso de medida (consultar pág. 10 de este documento)',
            '- Cubicaje: Conversión volumétrica 167kg/m3',
            '- Se admite la recogida y entrega en más de 200 puntos CTT Express con un servicio 24h sin coste adicional.',
            '- El Servicio Portugal incluye la entrega en más de 1,800 puntos de conveniencia <u>sin coste adicional</u>.',
          ],
        },
        {
          type: 'table',
          imageUrl: require('@/assets/ctt10-icon.png'),
          id: '10h',
        },
        {
          type: 'text',
          title: 'Características del servicio Ctt 10:00h:',
          list: [
            '- Peso máximo por bulto: 40 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas.',
            '- Cubicaje: Conversión volumétrica 167kg/m3',
            '- Cobertura: Toda la Península Ibérica (consultar poblaciones con suplemento de kilometraje en www.cttexpress.com).',
            '- Se admite la recogida y entrega en más de 200 puntos CTT Express con un servicio 24h <u>sin coste adicional</u>.',
            '- El Servicio Portugal incluye la entrega en más de 1,800 puntos de conveniencia <u>sin coste adicional</u>.',
          ],
        },
        {
          type: 'table',
          imageUrl: require('@/assets/ctt48-icon.png'),
          id: '48h',
        },
        {
          type: 'text',
          title: 'Características de los servicios Ctt 48h y Ctt e48h:',
          list: [
            '- Peso máximo por bulto: 40 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm.',
            '- Cubicaje: Conversión volumétrica 167kg/m3',
            '- El servicio Ctt e48h que disponga de teléfono móvil, se beneficiará GRATIS del <u>Preaviso de entrega</u>, el servicio de <u>Entrega flexible</u> y la <u>Predicción de franja horaria</u>.',
            '- Este servicio admite exceso de peso y exceso de medida (consultar pág. 10 de este documento).',
            '- El Servicio Portugal incluye la entrega en más de 1,800 puntos de conveniencia <u>sin coste adicional</u>.',
          ],
        },
      ],
      previousPages: 0,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_PDF_PRODUCT_TABLE_LIST]),
    productTableList() {
      return this[GET_PDF_PRODUCT_TABLE_LIST]
    },
    pageGroupedElements() {
      let pages = []
      let pageGroup = []
      let singleRow = false
      let doubleRow = false
      let rowElementCounter = 0

      for (let i = 0; i < this.elements.length; i++) {
        let actualElement = this.elements[i]
        if (actualElement.type !== 'text') {
          const numberOfRows = Object.keys(this.productTableList[actualElement.id].kgRows).length

          if (numberOfRows > 15) {
            singleRow = true
          } else if (numberOfRows > 7) {
            doubleRow = true
          }
        }
        if (singleRow) {
          if (rowElementCounter !== 0) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
            doubleRow = false
          }
          pageGroup.push(actualElement)
          pages.push(pageGroup)
          pageGroup = []
          singleRow = false
        } else if (doubleRow) {
          pageGroup.push(actualElement)
          rowElementCounter++
          if (rowElementCounter === 2 || rowElementCounter === this.elements.length) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
            doubleRow = false
          }
        } else {
          pageGroup.push(actualElement)
          rowElementCounter++
          if (
            (rowElementCounter === 3 && actualElement.type !== 'table') ||
            (rowElementCounter === 4 && actualElement.type === 'text') ||
            rowElementCounter === this.elements.length
          ) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
          }
        }
      }
      if (pageGroup.length) {
        pages.push(pageGroup)
      }
      return pages
    },
  },
  created() {
    this.$emit('updateTotalPages', { PeninsularTables: this.pageGroupedElements.length })
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('PeninsularTables')
  },
}
</script>
